
import Component from 'vue-class-component';
import Dataset from '@/shared/data/model/Dataset';
import AutoFlex from './AutoFlex.vue';

@Component
export default class TwoRows5050 extends AutoFlex {
  get autoFlexConfig(): Dataset {
    if (this.slotsNames.length < 2) return {};
    const [slot1, slot2] = this.slotsNames;
    return {
      vertical: true,
      [`${slot1}Basis`]: '50%',
      [`${slot1}Grow`]: '0',
      [`${slot1}Shrink`]: '0',
      [`${slot2}Basis`]: '50%',
      [`${slot2}Grow`]: '0',
      [`${slot2}Shrink`]: '0',
    };
  }
}
